export const PLAY_URL_ASTIR_BEACH_2 = "/happenings/astir-beach-2";
export const PLAY_URL_ASTIR_BEACH_3 = "/happenings/astir-beach-3";
